/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

export const regexVersion = /^(\d{1,9}\.){0,3}(\d{1,9})$/

export const regexUri = /^(?!https?:\/\/).+([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/

export const regexKey = /^([a-zA-Z\d]((?!(\.|-|_)(\.|-|_))[\w\d\-.]){0,128}[a-zA-Z\d])$/

export const regexUsername = /^([a-zA-Z\d]((?!(\.|-|_)(\.|-|_))[\w\d\-.]){1,128}[a-zA-Z\d])$/

export const regexProductName = /^[a-zA-Z0-9-_ ]+$/

export const regexAgreementCode = /^[a-z0-9.-]{2,30}$/

export const regexSubtype = /^[a-z0-9]+(-[a-z0-9]+)*$/

export const regexShopCode = /^[a-z0-9-]+$/

export const regexGeneralHumanIdentifier = /^[a-zA-Z0-9-_]+$/

// IMPORTANT NOTE: The method of extracting the desired function results in errors in Safari (macOS)
// due to unsupported regex somewhere else in the index.js file. Making a copy of "escapeRegExp" helps to avoid this issue.
// TODO: Move the "escapeRegExp" method outside the Index.js file and then use it for development

// export const { escapeRegExp } = require('../../index')
export const escapeRegExp = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export default {
  regexVersion,
  regexUri,
  regexKey,
  regexUsername,
  regexProductName,
  regexAgreementCode,
  regexSubtype,
  regexShopCode,
  regexGeneralHumanIdentifier,
  escapeRegExp
}
